var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49967 5.16683C7.49967 4.79864 7.2012 4.50016 6.83301 4.50016C6.46482 4.50016 6.16634 4.79864 6.16634 5.16683V8.50016C6.16634 8.86835 6.46482 9.16683 6.83301 9.16683H8.83301C9.2012 9.16683 9.49967 8.86835 9.49967 8.50016C9.49967 8.13197 9.2012 7.8335 8.83301 7.8335H7.49967V5.16683Z",
    fill: "#9E0A05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.49967 0.833496C3.81778 0.833496 0.833008 3.81826 0.833008 7.50016C0.833008 11.1821 3.81778 14.1668 7.49967 14.1668C11.1816 14.1668 14.1663 11.1821 14.1663 7.50016C14.1663 3.81826 11.1816 0.833496 7.49967 0.833496ZM2.16634 7.50016C2.16634 4.55464 4.55416 2.16683 7.49967 2.16683C10.4452 2.16683 12.833 4.55464 12.833 7.50016C12.833 10.4457 10.4452 12.8335 7.49967 12.8335C4.55416 12.8335 2.16634 10.4457 2.16634 7.50016Z",
    fill: "#9E0A05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedClock);
export default __webpack_public_path__ + "static/media/red-clock.b9d9b990ee8fae118653a3aa17d89893.svg";
export { ForwardRef as ReactComponent };